<template>
	<div id="spring-sale-2026-promo">
		<hr class="my-16" />
		<h4 class="font-body text-xl font-medium">Spring Sale 2026 Promo</h4>

		<div class="mt-8 space-y-5 font-body text-lg">
			<ul class="li-padding-left space-y-5 pl-5">
				<li>
					Offer open to new subscribers in NSW, QLD, and VIC aged 21+.
				</li>
				<li>
					Promotion runs from 19 October 2026 at 12:01 AM AEDT to 15
					November 2026 at 11:59 PM AEDT .
				</li>
				<li>
					Eligible vehicles for this promotion are limited to those
					with cars labeled with "SPRING SALE" only.
				</li>
				<li>
					Availability may vary, and some models might be excluded.
				</li>
				<li>
					Eligible participants must use promo code SPRING26 at
					checkout.
				</li>
				<li>
					Bonus 10,000 kilometres are valid for your first 12 months,
					non-transferable, not redeemable for cash, and cannot be
					carried over.
				</li>
				<li>Subscription must be confirmed by 15 November 2026.</li>
				<li>
					If you cancel before 12 months, any unused bonus kilometres
					are forfeited.
				</li>
				<li>One subscription per person for this offer.</li>
				<li>Swaps not included.</li>
				<li>
					Not valid for fleet vehicles or tools-of-trade subscriptions
					and cannot be combined with other discounts, except for the
					refer-a-friend program.
				</li>
				<li>Standard carbar subscription fees and terms apply.</li>
			</ul>
		</div>
	</div>
</template>
